module.exports = __webpack_public_path__ + "static/media/add-icon-dark.3964a1b8.svg";